import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-draw-popup',
  templateUrl: './draw-popup.component.html',
  styleUrls: ['./draw-popup.component.scss']
})
export class DrawPopupComponent implements OnInit {

  @Input() jobs: number;
  @Output() createRoute: EventEmitter<any> = new EventEmitter();
  constructor() { }

  ngOnInit(): void {
  }

  createRouteClicked(): void {
    this.createRoute.emit(true);
  }

}
